let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eVgfI")).then(() => parcelRequire('1LaWe'));